import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';
import messages from './JobOfferBox.intl';

import styles from './JobOfferBox.module.scss';

import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR } from 'common/consts/common';

import ApplyImg from 'common/images/APPLY.svg';

import LanguageService from 'services/Language.service';

@injectIntl
export default class JobOfferBoxComponent extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    cities: PropTypes.array.isRequired,
    country: PropTypes.string,
    logo: PropTypes.string.isRequired,
    isArticleView: PropTypes.bool,
  };

  currentLanguage = LanguageService.getLang();

  render() {
    const { slug, name, cities, country, logo, isArticleView } = this.props;

    const citiesList = cities.map((location, i) => (
      <span key={i} className={styles.SpanCity}>
        {location}
      </span>
    ));
    return (
      <div className={styles.JobOfferBox}>
        {isArticleView && (
          <div className={styles.LogoWrapper}>
            <img className={styles.Logo} src={logo} alt="Company logo" />
          </div>
        )}
        <div className={styles.Container}>
          {!isArticleView && (
            <div className={styles.LogoWrapper}>
              <img className={styles.Logo} src={logo} alt="Company logo" />
            </div>
          )}
          <div className={styles.ContainerDetails}>
            <Link
              to={{
                pathname: `${ANCHOR.JOBOFFERS[this.currentLanguage]}/${slug}`,
                state: { jobOfferSlug: slug }
              }}
            >
              <h2 className={styles.SpanName}>{name}</h2>
            </Link>
            <div className={styles.DivCities}>{citiesList}</div>
            {country && <span className={styles.SpanCountry}>{country}</span>}
          </div>
          <div className={styles.ContainerApply}>
            <Link
              to={{
                pathname: `${ANCHOR.JOBOFFERS[this.currentLanguage]}/${slug}`,
                state: { jobOfferSlug: slug }
              }}
            >
              <img src={ApplyImg} alt="Apply icon" />
              <span className={styles.SpanApply}>
                {this.props.intl.formatMessage(messages.apply)}
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/JobOffersList/JobOfferBox/JobOfferBox.js